<template>
    <SwipeModalComponent v-if="homeMenu.isVisible" @closeMenu="changeHomeMenuVisibility">
        <div class="content-wrapper">
            <h2 v-text="getNMRESPCONS"></h2>
            <div class="menu-itens-container" v-for="(item, hmikey) in homeMenu.itens" :key="hmikey">
                <div v-permission="item.permission" v-if="isVisibleButtons(item)"  class="menu-itens" @click="emitEvent(item)">
                    <i :class="`fa fas ${item.icon}`"></i>
                    <h3 v-text="item.name"></h3>
                    <span v-text="'➤'"></span>
                </div>
            </div>
            <div class="footer-item-container">
                <div class="footer-item" v-for="(item, hmikey) in homeMenu.footerItens" :key="hmikey"
                    @click="emitEvent(item)">
                    <i :class="`fa fas ${item.icon}`"></i>
                    <h3 v-text="item.name"></h3>
                </div>
            </div>
        </div>
        <PoweredBy></PoweredBy>
    </SwipeModalComponent>
</template>
<script>
import SwipeModalComponent from '../bottom-popups/SwipeModalComponent.vue'
import PoweredBy from '@/components/stripes/PoweredBy.vue'
import { mapGetters, mapActions } from 'vuex'
import { callWppHelp, hasWppParam } from '@/libs/Util.js'

export default {
    name: 'HomeMenuComponent',
    emits: ['componentEvent'],
    components: {
        SwipeModalComponent,
        PoweredBy
    },
    data () {
        return {}
    },
    computed: {
        ...mapGetters(['homeMenu', 'retailGeneralParams', 'getNMRESPCONS', 'retailGeneralParams'])
    },
    methods: {
        ...mapActions(['changeHomeMenuVisibility']),
        emitEvent: function (item) {
            this.changeHomeMenuVisibility()

            if (item.external) {
                return callWppHelp()
            }
            this.$emit('componentEvent', item)
        },
        hasWppParam: function () {
            return hasWppParam()
        },
        isVisibleButtons (button) {
            switch (button.action) {
            case '/help':
                return this.hasWppParam()
            default:
                return true
            }
        }
    }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    margin-bottom: 50px;

    h2 {
        text-align: center;

        &:last-of-type {
            margin-bottom: 30px;
        }
    }

    .menu-itens-container {
        padding: 0 15px;
        height: calc(calc(100% - 30%) - 45px);
        overflow: auto;

        .menu-itens {
            position: relative;
            display: grid;
            grid-template-columns: 30px calc(100% - 60px) 30px;
            border-bottom: solid #BAB8B8 2px;
            padding: 0 0 20px 0;
            margin-bottom: 20px;

            span {
                color: var(--iconColor);
                text-align: right;
            }

            i {
                color: var(--iconColor);
                margin: auto 0;
            }

            h3,
            span {
                margin: auto 0;
            }
        }
    }

    .footer-item-container {
        position: relative;
        left: 15px;
        height: 45px;
        display: block;
        margin-top: 20px;

        i {
            color: var(--iconColor);
            margin-right: 15px;
        }

        i,
        h3 {
            display: inline-block;
        }
    }
}
</style>
